import Helpers from "../../commons/helpers";
import MessageClient from "./MessageClient";
import { IPagedList } from "../../commons/interfaces";
import { Constants } from "../../constants/constants";
import { IMembers, IRecordChannel } from "../../containers/channel/useChannel";

const ChannelService = {
    getPaged: async (request: {
        communityId: string;
        searchText?: string;
        orderBy?: string;
        pageSize?: number;
        pageNumber?: number;
    }): Promise<IPagedList<IRecordChannel>> => {
        const str = Helpers.handleFormatParams(request);
        const result = await MessageClient().get(`${Constants.ApiPath.CHANNEL.GET_PAGED}?${str}`);
        return result.data.result;
    },

    getDetail: async (id: string): Promise<IRecordChannel> => {
        const result = await MessageClient().get(`${Constants.ApiPath.CHANNEL.GET_DETAIL}/${id}`);
        return result.data.result;
    },

    getMemberPaged: async (request: {
        id: string;
        type: number;
        roles?: string[];
        orderBy?: string;
        pageSize?: number;
        pageNumber?: number;
    }): Promise<IPagedList<IMembers>> => {
        const str = Helpers.handleFormatParams(request);

        const result = await MessageClient().get(`${Constants.ApiPath.CHANNEL.GET_MEMBER_PAGED}?${str}`);

        return result.data.result;
    },

    create: async (request: {
        clientId: string;
        name: string;
        accessMode: number;
        description: string;
        communityId: string;
        referenceId: string;
        avatarImage: string;
        avatarImageUrl: string;
        organizationId?: string;
    }) => {
        const result = await MessageClient().post(Constants.ApiPath.CHANNEL.CREATE, request);
        return result.data.result;
    },

    update: async (request: {
        id: string;
        name: string;
        accessMode: number;
        description: string;
        avatarImage: string;
        avatarImageUrl: string;
        referenceId?: string;
        organizationId?: string;
        updateTime: string;
    }) => {
        const result = await MessageClient().put(Constants.ApiPath.CHANNEL.UPDATE, request);
        return result.data.result;
    },

    delete: async (id: string) => {
        const result = await MessageClient().delete(`${Constants.ApiPath.CHANNEL.DELETE}/${id}`);
        return result.data.result;
    },

    join: async (id: string) => {
        const result = await MessageClient().post(`${Constants.ApiPath.CHANNEL.JOIN}/${id}`);
        return result.data;
    },
};

export default ChannelService;
